import Vue from 'vue'
import Router from 'vue-router' 
import VueMeta from 'vue-meta'

Vue.use(Router)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

export default new Router({
  mode: 'history',
  routes: [   
    {
      path: '*',
      name: 'notfoundpage',
      component: () => import(/* webpackChunkName: "NotFoundPage" */ '@/views/NotFoundPage.vue'),
    },
    {
      path: '/',
      name: 'Landing',
      component: () => import(/* webpackChunkName: "Landing" */ '@/views/Landing-FaceAI.vue'),
    },
    // {
    //   path: '/signup',
    //   name: 'SignUp',
    //   component: () => import(/* webpackChunkName: "SignUp" */ '@/views/SignUp.vue'),
    // },
    {
      path: '/book-demo',
      name: 'BookDemo',
      component: () => import(/* webpackChunkName: "SignUp" */ '@/views/BookDemo.vue'),
    },
    // {
    //   path: '/pricing',
    //   name: 'Pricing',
    //   component: () => import(/* webpackChunkName: "Pricing" */ '@/views/Pricing.vue'),
    // },
    {
      path: '/contact',
      name: 'ContactUs',
      component: () => import(/* webpackChunkName: "ContactUs" */ '@/views/ContactUs.vue'),
    },
    {
      path: '/careers',
      name: 'Careers',
      component: () => import(/* webpackChunkName: "Careers" */ '@/views/Careers.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Scroll to the saved position if navigating back
    } else {
      return { x: 0, y: 0 }; // Scroll to top
    }
  },
});
